import {fromLonLat} from "ol/proj";

import global from "../global.js";

const log = global.log.getLogger("f_mtac.scene.GisNode");
log.setLevel(log.levels.WARN);

/**
 * This class is responsible for google map node.
 * The googlemap is embedded in an OpenLayers layer
 * @constructor
 */
const GisNode = function (view) {
    var brightness;
    const ol_driver = view.ol_driver;
    log.debug("GisNode", {ol_driver});

    Object.defineProperties(this, {
        brightness: {
            set: (new_brightness) => {
                brightness = new_brightness;
                let element = document.getElementById("map");
                if (element !== null) {
                    element.style.filter = `brightness(${brightness})`;
                }
            },
            get: () => brightness
        }
    });

    /**
     * Activate Google Maps or OSM in OpenLayers for GIS SITAC setup assistant
     * @returns {boolean} true if success, false if error (can not load google map)
     */
    this.activate = async function () {
        log.debug("activate");

        if (await ol_driver.add_map_layer()) {
            // default: center on France
            const DEFAULT_LON = 2.2;
            const DEFAULT_LAT = 46.23;
            const DEFAULT_ZOOM = 6;
            const lon = global.default_configuration.center?.lon || DEFAULT_LON;
            const lat = global.default_configuration.center?.lat || DEFAULT_LAT;
            let zoom = global.default_configuration.center?.zoom || DEFAULT_ZOOM;
            let center = fromLonLat([lon, lat]);
            ol_driver.set_center_and_zoom(center, zoom);
            return true;
        }
        return false;
    };

    /**
     * Close all the OpenLayers layers
     */
    this.close = function () {
        log.debug("close");
        ol_driver.remove_map_layer();
    };
};

export default GisNode;
